import api from './client';
import { Timestamp } from 'firebase/firestore';
import type { EmailTemplate } from 'types/email_template';

function toTimestamp(value: any): Timestamp {
  if (!value) return Timestamp.now();
  if (value instanceof Timestamp) return value;
  if (typeof value === 'string') {
    return Timestamp.fromDate(new Date(value));
  }
  if (value.seconds !== undefined) {
    return new Timestamp(value.seconds, value.nanoseconds || 0);
  }
  return Timestamp.now();
}

function apiResponseToEmailTemplate(response: any): EmailTemplate {
  return {
    ...response,
    created_at: toTimestamp(response.created_at),
  };
}

export const emailTemplatesApi = {
  list: async (params?: { org_id?: string; limit?: number }): Promise<EmailTemplate[]> => {
    const { data } = await api.get('/email-templates', { params });
    return (data as any[]).map(apiResponseToEmailTemplate);
  },

  create: async (template: Omit<EmailTemplate, 'id' | 'created_at'> & { org_id: string }): Promise<EmailTemplate> => {
    const { data } = await api.post('/email-templates', template);
    return apiResponseToEmailTemplate(data);
  },

  update: async (templateId: string, updates: Partial<EmailTemplate>): Promise<EmailTemplate> => {
    const { data } = await api.patch(`/email-templates/${templateId}`, updates);
    return apiResponseToEmailTemplate(data);
  },

  delete: async (templateId: string): Promise<void> => {
    await api.delete(`/email-templates/${templateId}`);
  },

  reorder: async (updates: { id: string; order: number }[]): Promise<void> => {
    await api.patch('/email-templates/reorder', { updates });
  },
};
